import { Node, mergeAttributes } from '@tiptap/core';
var TableRow = Node.create({
  name: 'tableRow',
  addOptions: function addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: '(tableCell | tableHeader)*',
  tableRole: 'row',
  parseHTML: function parseHTML() {
    return [{
      tag: 'tr'
    }];
  },
  renderHTML: function renderHTML(_ref) {
    var HTMLAttributes = _ref.HTMLAttributes;
    return ['tr', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  }
});
export { TableRow, TableRow as default };